<template>
    <Card
        class="well p-0 p-sm-5"
        :class="{
            'py-md-4 py-lg-8': compact !== false,
            'gradient': !bgImage,
            'flush': flush,
        }"
        :style="{
            'background-image': bgImage && `url(${bgImage})`
        }"
    >

        <div class="well-container">
            <slot />
        </div>

    </Card>
</template>


<script>
    import Card from '~/components/cards/Card.vue';

    export default {
        props: {
            bg:      String,
            compact: Boolean,
            flush:   Boolean,
            double:  Boolean,
        },

        components: {
            Card,
        },

        data () {
            return {};
        },

        computed: {
            bgImage () {
                return this.bg && '/images/creative-practice/subscribe-well.png';
            },
        },
    }
</script>


<style lang="postcss" scoped>
    .well {
        margin-right:  -16px;
        margin-left:   -16px;
        border-radius: 0;

        @media screen and (max-width: 575px) {
            box-shadow: none;
        }

        @media screen and (min-width: 576px) {
            background-color: #1B8BDF;
            background-repeat: no-repat;
            background-position: 50% 50%;
            background-size: cover;
        }

        @media screen and (min-width: 768px) {
            margin-right: -32px;
            margin-left:  -32px;
        }

        @media screen and (min-width: 992px) {
            margin-right:  0;
            margin-left:   0;
            border-radius: 8px;
        }

        &.flush {
            margin-right:  0;
            margin-left:   0;
            border-radius: 0;
        }
    }

    .well-container {
        margin: 0;

        display:         flex;
        flex-flow:       row wrap;
        justify-content: center;
        align-items:     stretch;

        @media screen and (min-width: 576px) {
            margin: -12px;
        }

        @media screen and (min-width: 992px) {
            margin: -20px;

            flex-flow: row nowrap;
        }
    }

    .gradient {
        @media screen and (min-width: 576px) {
            background: linear-gradient(103deg, #99589F 10.15%, #ED4D81 49.15%, #FB8C41 93.35%);
        }
    }

    .h-stretch {
        height: 100%;
    }
</style>
